import {Button, Divider, Layout, Tabs, Typography} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import EMSA from './EMSA';
import ModTabs from './ModTabs';
import StanTabs from './StanTabs';
import SWB from './SWB';

const {Paragraph, Text} = Typography;
const {Content} = Layout;

const DEDesignLogic = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);
  // const [Tno,   setTno] = useState(appColors['ColorX']);
  // const [Gno,   setGno] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      // setTno(appColors['ColorX'])
      // setGno(appColors['ColorG2'])
    } else if (key === 'dos') {
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno('white');
      setGUno(appColors['ColorX']);
      // setTno(appColors['ColorX'])
      // setGno(appColors['ColorG2'])
    }
  };
  const items_ = [
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>EMSA</Button>, key: 'uno', children: <EMSA/>},
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>South Western Blot</Button>, key: 'dos', children: <SWB/>},
  ];
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Paragraph className='Title2' style={{color: appColors['ColorNa'], fontSize: '6.4vh'}}>Workflow for the experimental design</Paragraph>
      <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Characterization of the interactions between the aptamers and CRP</Paragraph>
      <Text className='BaseText2'>The first phase of our experimental pipeline was to characterize well the aptamers for our biosensor. We wanted to make sure that the sequences of the aptamers we chose had the appropriate affinity and specificity towards CRP. For this purpose we proposed the protocols of EMSA and Southwestern Blot.</Text>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='4vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
      <Divider/>
      <ModTabs/>
      <br/>
      <StanTabs/>
      <Divider/>
      <br/><br/>
    </Layout>
  );
};

export default DEDesignLogic;
